import { render, staticRenderFns } from "./CheckReferenceFieldsModal.vue?vue&type=template&id=a8853604"
import script from "./CheckReferenceFieldsModal.vue?vue&type=script&lang=js"
export * from "./CheckReferenceFieldsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports